export const decodeBase64Url = (base64Url) => {
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) {
        base64 += '=';
    }
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
};

export const decryptLinkPayload = async (encryptedPart, marketingEncryptionKey) => {
    try {
        const [ivBase64Url, encryptedBase64Url] = encryptedPart.split('.');

        if (!ivBase64Url || !encryptedBase64Url) {
            throw new Error('Invalid encrypted format.');
        }

        const encoder = new TextEncoder();
        const keyData = encoder.encode(marketingEncryptionKey);
        const keyHash = await window.crypto.subtle.digest('SHA-256', keyData);

        const ivBytes = decodeBase64Url(ivBase64Url);
        const ciphertextBytes = decodeBase64Url(encryptedBase64Url);

        const cryptoKey = await window.crypto.subtle.importKey(
            'raw',
            keyHash,
            { name: 'AES-CBC' },
            false,
            ['decrypt']
        );

        const decryptedBuffer = await window.crypto.subtle.decrypt(
            {
                name: 'AES-CBC',
                iv: ivBytes,
            },
            cryptoKey,
            ciphertextBytes
        );

        const decoder = new TextDecoder();
        return decoder.decode(decryptedBuffer);
    } catch (error) {
        console.error('Failed to decrypt link payload', error);
        return null; // Return null on error, let the caller handle it
    }
};

export const getEncryptionKey = () => {
    let key = process.env.REACT_APP_MARKETING_ENCRYPTION_KEY;
    if (!key || key.length < 60) {
        key = '5RcAvPfMozAFczejyPd$5q6NxSzYjdgM8b8kZ454PWMTim&MnZFaGHJZmuk7eYSC';
    }
    return key;
};
